import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample, type Store } from 'effector'
import { model as moviesModel } from '~/entities/movies'
import { init, initRecommendedVodsPage } from '../root/model'

// Events

export const left = createEvent()

const $recommendedVodsTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('recommended')
)

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

sample({
  clock: init,
  target: initRecommendedVodsPage,
})

/********** Skeleton logics starts ***********/
sample({
  clock: api.vods.loadRealRecommendedVodsFx.pending, // TODO should be attach
  target: setContentLoading,
})
/********** Skeleton logics ends ***********/

register($recommendedVodsTitle, '$search/recommendedVodsTitle')
register(moviesModel.$formattedRecommendedVods, '$search/recommendedVods')
